import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import LoadingPage from "../../Components/layouts/loading";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import StepRoutes from "../../Routes/steps_routes";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import WhatsappTemplateTable from "./WhatsAppTemplate/whatsapp_template";
import { IoLogoWhatsapp } from "react-icons/io";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useLocation, useNavigate } from "react-router";

const WhatsappTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const pageFromURL = parseInt(queryParams.get("page")) || 1;
  const [page, setPage] = useState(pageFromURL);

  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", getFilteredURL("/cherrioSystem/getAll", page))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.whatsAppLogCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="page-header d-print-none">
          <div className="container-xl">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <IoLogoWhatsapp style={{ color: "green" }} />
                  Whats App Template
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="container-xxl">
            <div className="row">
              <div className="col-md-12 col-sm-12 py-2">
                <div className="card">
                  {data && (
                    <WhatsappTemplateTable
                      data={data?.data}
                      currentPage={page}
                      itemsPerPage={50}
                      onView={(item) => {
                        setSelectedTemplate(item);
                        setShowModal(true);
                      }}
                    />
                  )}

                  {showModal && (
                    <>
                      <div className="modal d-block" tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">
                                {selectedTemplate?.templateName}
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(false)}
                              ></button>
                            </div>

                            <div className="modal-body">
                              {selectedTemplate?.templateComponent?.map(
                                (comp, i) => (
                                  <div key={i} className="mb-4">
                                    <h6 className="fw-bold">
                                      Type: {comp.type}
                                    </h6>

                                    {/* HEADER */}
                                    {comp.type === "HEADER" && (
                                      <p>
                                        <strong>Format:</strong> {comp.format}{" "}
                                        <br />
                                        {comp.text}
                                      </p>
                                    )}

                                    {/* BODY */}
                                    {comp.type === "BODY" && (
                                      <p style={{ whiteSpace: "pre-line" }}>
                                        {comp.text}
                                      </p>
                                    )}

                                    {/* FOOTER */}
                                    {comp.type === "FOOTER" && (
                                      <p className="text-muted">{comp.text}</p>
                                    )}

                                    {/* BUTTONS */}
                                    {comp.type === "BUTTONS" && (
                                      <div>
                                        {comp.buttons?.map((btn, idx) => (
                                          <div key={idx} className="mb-2">
                                            {/* <span className="badge bg-primary me-2">
              {btn.type}
            </span> */}

                                            <strong>{btn.text}</strong>

                                            {btn.type === "PHONE_NUMBER" && (
                                              <div>📞 {btn.phone_number}</div>
                                            )}

                                            {btn.type === "URL" && (
                                              <div>
                                                🔗 {btn.url}
                                                {btn.example && (
                                                  <div className="text-muted small">
                                                    Example: {btn.example[0]}
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                )
                              )}
                            </div>

                            <div className="modal-footer">
                              <button
                                className="btn btn-secondary"
                                onClick={() => setShowModal(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-backdrop fade show"></div>
                    </>
                  )}

                  <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    pageDatalength={data?.whatsAppLog?.length}
                    showPage={showPage}
                    setShowPage={setShowPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WhatsappTemplate;
